import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { Container } from 'reactstrap';

export class BasicContentItem extends Component {

  render() {
    try {
      this.image = this.props.image.sizes.large;
    } catch(e){}


    return (
      <div>
        {
          Boolean(this.image) &&
          <div className="parallax-image"
               style={{ backgroundImage: `url(${this.image || require('../../assets/images/no-image.png')})`}}/>
        }
        <Container className={"p-0"}>
          <Row className={ this.props.itemStyle }>
            <Col xs="12" md={{ size: 10, offset: 1 }} className={"basic-container-content"}>
              <h2>{ this.props.title }</h2>
              <p dangerouslySetInnerHTML={{
                   __html: this.props.content
                }}/>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/item/BasicContentItem.js